export type ButtonVariant = 'primary' | 'success' | 'danger' | 'warning' | 'simple' | 'ghost' | 'project';
export type ButtonSize = '3xs' | '2xs' | 'xs' | 'sm' | 'md' | 'xl';

export const BTN_BASE =
    'inline-flex items-center gap-2 rounded-md focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors';

export const BTN_VARIANTS: Record<ButtonVariant, string> = {
    primary: 'bg-indigo-500 text-white hover:bg-indigo-600 focus-visible:outline-indigo-600 shadow-xs',
    success: 'bg-green-600 text-white hover:bg-green-700 focus-visible:outline-green-600 shadow-xs',
    danger: 'bg-red-400 text-white hover:bg-red-500 focus-visible:outline-red-600',
    warning: 'bg-yellow-400 text-white hover:bg-yellow-500 focus-visible:outline-yellow-600',
    simple: 'bg-white text-gray-800 hover:bg-gray-100 border border-slate-300 focus-visible:outline-gray-200 shadow-xs',
    ghost: 'bg-transparent text-gray-700 hover:bg-gray-50',
    project: 'bg-gray-100 hover:bg-gray-200 shadow-xs border-1 border-gray-300 cursor-pointer text-gray-900'
};

export const BTN_SIZES: Record<ButtonSize, string> = {
    '3xs': 'px-0.5 py-0.25 text-xs',
    '2xs': 'px-1.5 py-0.5 text-xs',
    xs   : 'px-2 py-1 text-xs',
    sm   : 'px-3 py-1.5 text-xs',
    md   : 'px-4 py-2 text-sm',
    xl   : 'px-5 py-2 text-base font-semibold tracking-wide',
};
